import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import dayjs from 'dayjs';
import { actions } from 'features/transaction';

export const useWithdrawalHistory = () => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale);
  const { withdrawalHistory } = useSelector(state => state.transaction, shallowEqual);
  const { currency } = useSelector(state => state.auth, shallowEqual);

  const [values, setValues] = useState({
    login: '',
    amount: '',
    userId: '',
    status: [0, 1, 2],
    page: 0,
    count: 7,
  });

  const [dateRanges, setDateRanges] = useState({
    from: dayjs().subtract(1, 'month').toDate(),
    to: new Date(),
  });

  const pages = Math.ceil(withdrawalHistory?.items?.length / values.count) || 1;

  const items =
    withdrawalHistory?.items?.slice(values.page * values.count, (values.page + 1) * values.count)?.map(item => ({
      ...item,
      date: dayjs(item.created_at).format('DD.MM.YYYY, HH:mm'),
      amount: `${item.amount} ${currency}`,
    })) || [];

  const handleFromChange = date => {
    setDateRanges(ps => ({ ...ps, from: date }));
  };

  const handleToChange = date => {
    setDateRanges(ps => ({ ...ps, to: date }));
  };

  const handleStatusChange = status => {
    setValues(ps => {
      const exists = ps.status.includes(status);
      return { ...ps, status: exists ? ps.status.filter(s => s !== status) : [...ps.status, status] };
    });
  };

  const handleLoginChange = value => {
    setValues(ps => ({ ...ps, login: value }));
  };

  const handleAmountChange = value => {
    setValues(ps => ({ ...ps, amount: value }));
  };

  const handleUserIdChange = value => {
    setValues(ps => ({ ...ps, userId: value }));
  };

  const handlePageChange = page => {
    setValues(ps => ({ ...ps, page }));
  };

  const handleWithdrawalHistorySubmit = e => {
    e.preventDefault();

    const statusMapping = {
      0: 'CREATED',
      1: 'PAID',
      2: 'CANCELED',
    };

    dispatch(
      actions.getWithdrawalHistory({
        page: 0,
        count: values.count,
        login: values.login || undefined,
        amount: values.amount || undefined,
        user_id: values.userId || undefined,
        statuses: values.status.length ? values.status.map(s => statusMapping[s]).join(',') : undefined,
        date_from: dateRanges.from ? dayjs(dateRanges.from).startOf('day').format('YYYY-MM-DD HH:mm') : undefined,
        date_to: dateRanges.to ? dayjs(dateRanges.to).endOf('day').format('YYYY-MM-DD HH:mm') : undefined,
      }),
    );
    setValues(ps => ({ ...ps, page: 0 }));
  };

  useEffect(() => {
    dispatch(
      actions.getWithdrawalHistory({
        page: values.page,
        count: values.count,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.page]);

  return {
    input: {
      values,
      dateRanges,
      handleFromChange,
      handleToChange,
      handleStatusChange,
      handleLoginChange,
      handleAmountChange,
      handleUserIdChange,
      handlePageChange,
      handleWithdrawalHistorySubmit,
    },
    output: {
      locale,
      items,
      pages,
      currency,
    },
  };
};
